export const useValidationRules = () => {
  return {
    rules: {
      required: (value) => !!value || 'Field is required',
      counter_1: (value) => !value || value.length <= 1 || 'Max 1 character',
      counter_3: (value) => !value || value.length <= 3 || 'Max 3 characters',
      counter_4: (value) => !value || value.length <= 4 || 'Max 4 characters',
      counter_5: (value) => !value || value.length <= 5 || 'Max 5 characters',
      counter_10: (value) => !value || value.length <= 10 || 'Max 10 characters',
      counter_16: (value) => !value || value.length <= 16 || 'Max 16 characters',
      counter_17: (value) => !value || value.length <= 17 || 'Max 17 characters',
      counter_20: (value) => !value || value.length <= 20 || 'Max 20 characters',
      counter_25: (value) => !value || value.length <= 25 || 'Max 25 characters',
      counter_30: (value) => !value || value.length <= 30 || 'Max 30 characters',
      counter_50: (value) => !value || value.length <= 50 || 'Max 50 characters',
      counter_60: (value) => !value || value.length <= 60 || 'Max 60 characters',
      counter_75: (value) => !value || value.length <= 75 || 'Max 75 characters',
      counter_100: (value) => !value || value.length <= 100 || 'Max 100 characters',
      counter_200: (value) => !value || value.length <= 200 || 'Max 200 characters',
      counter_500: (value) => !value || value.length <= 500 || 'Max 500 characters',
      counter_1000: (value) => !value || value.length <= 1000 || 'Max 1000 characters',
      counter_2000: (value) => !value || value.length <= 2000 || 'Max 2000 characters',
      counter_4000: (value) => !value || value.length <= 4000 || 'Max 4000 characters',
      counter_5000: (value) => !value || value.length <= 5000 || 'Max 5000 characters',
      YN: (value) => !value || /^[YyNn]$/.test(value) || 'Must be Y or N',
      day31: (value) => !value || (value <= 31 && /^\d+$/.test(value)) || 'Day must be less than 31.',
      rate_100: (value) => !value || (value >= 0 && value <= 100) || 'Rate must be between 0 and 100',
      price_0: (value) => !value || value > 0 || 'Price must be over than 0',
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return !value || pattern.test(value) || 'E-mail must be valid'
      },
      emailList: (value) => {
        if (!value) return true

        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        for (const v of value.split(',')) {
          if (!!v && !pattern.test(v.trim())) {
            return 'E-mail must be valid'
          }
        }

        return true
      },
      phone: (value) => {
        const pattern = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g
        return !value || pattern.test(value) || 'Not a valid phone number'
      },
      code: (value) => {
        const pattern = /[^0-9A-Za-z \.\/_-]/
        return !value || !pattern.test(value) || 'Special Character not allowed'
      },
      number: (value) => {
        const pattern = /^-?\d*(\.\d+)?$/
        return !value || pattern.test(value) || 'Not a valid number'
      },
      specialCharacter: (value) => {
        const pattern = /[^\w\s]/
        return !value || !pattern.test(value) || 'Special Character not allowed'
      },
      ccNumber: (value) => {
        value = value.replace(/\D/g, '')
        if (value.length < 15 || value.length > 16) {
          return false
        }
        let sum = 0
        let shouldDouble = false
        for (let i = value.length - 1; i >= 0; i--) {
          let digit = parseInt(value.charAt(i))
          if (shouldDouble) {
            digit *= 2
            if (digit > 9) {
              digit -= 9
            }
          }
          sum += digit
          shouldDouble = !shouldDouble
        }
        return sum % 10 === 0
      },
      ccExpDate: (value) => {
        const regex = /^(0[1-9]|1[0-2])\/([0-9]{2})$/
        if (!regex.test(value)) {
          return false
        }
        const [month, year] = value.split('/')
        const currentDate = new Date()
        const currentYear = currentDate.getFullYear() % 100
        const currentMonth = currentDate.getMonth() + 1
        if (parseInt(year) > currentYear || (parseInt(year) === currentYear && parseInt(month) >= currentMonth)) {
          return true
        } else {
          return false
        }
      },
      ccCvv: (value, ccType) => {
        const regexMap = {
          visa: /^\d{3}$/,
          mastercard: /^\d{3}$/,
          amex: /^\d{4}$/,
          discover: /^\d{3}$/,
          unknown: /^\d{3}$/
        }
        if (!regexMap[ccType.toLowerCase()]) {
          ccType = 'unknown'
          //return false
        }
        return regexMap[ccType.toLowerCase()].test(value)
      },
      fileRequired: (value) => {
        if (value && Array.isArray(value)) {
          if (value.length == 0) return 'File is required'
        } else {
          return !!value || 'File is required'
        }
      },
      files: (value, maxCount = 3, maxSizeMB = 2) => {
        const maxSize = maxSizeMB * 1024 * 1024 // 2 MB
        const errorMessage = `image size should be less than ${maxSizeMB} MB`
        // Multiple files
        if (value && Array.isArray(value)) {
          /*
          const totalSize = value.reduce((acc, current) => acc + current.size, 0)
          return totalSize < maxSize || errorMessage
          */
          for (const file of value) {
            if (file.size >= maxSize) {
              return errorMessage
            }
          }

          return value.length <= maxCount || `Max file count should be ${maxCount}`
        }

        // Single file (if multiple is undefined or set to false)
        return !value || value.size < maxSize || errorMessage
      }
    }
  }
}
